import glamorous from 'glamorous';
import { Sizes } from 'module/View/Common';

export const InnerWrapper = glamorous.div({
  padding: `${Sizes.langTopBarHeight}px ${Sizes.gutter / 2}px ${Sizes.gutter / 2}px ${Sizes.gutter}px`,
  display: 'flex',
  flexDirection: 'column',
  '& > *': {
    flexShrink: 0,
  },
});

type WrapperProps = {
  top: number;
  windowHeight: number;
  menuWidth: number;
};

const Wrapper = glamorous.div<WrapperProps>(p => ({
  position: 'fixed',
  zIndex: 900,
  margin: 0,
  top: p.top,
  left: 0,
  right: 0,
  background: 'white',
  width: p.menuWidth - Sizes.gutter / 2,
  overflow: 'hidden',
  opacity: 0,
  transition: 'opacity 0.3s',
  transform: `translateX(-100%) translateZ(0px)`,
  bottom: 0,
}));

export const DesktopWrapper = glamorous(Wrapper)(p => ({
  // maxHeight: p.windowHeight - p.top,
}));

export const TabletWrapper = glamorous(Wrapper)(p => ({
  // maxHeight: p.windowHeight - p.top,
}));

export const MobileWrapper = glamorous(Wrapper)(p => ({
  // bottom: 0,
}));



// WEBPACK FOOTER //
// ./src/module/View/Menu/MenuWrapper.s.ts